import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { Media } from '../../mediaSetting';

// props is below:
// theme: 'org','group','wa','mr' (color picker)
// title:
// subtitle:
// helpFunc:
// helpLink: (if you put helpFunc, no need to put this)

export default class PopupHeader extends React.Component {
  render() {
    let displayHelpHeader = '';

    let helpClass = 'helpIconVerticalCentral ui icon help circle text-size-xl fr hand helper-color-behaviour';
    if (this.props.helpFunc) {
      displayHelpHeader = (
        <i onClick={this.props.helpFunc || (() => window.open(this.props.helpLink, '_blank'))} className={helpClass} />
      );
    } else {
      displayHelpHeader = (
        <div>
          <Container fluid as={Media} greaterThanOrEqual="computer" className="full-height">
            <a href={this.props.helpLink} target="mgt-console-help" className="display-flex center-flex full-height">
              <i className={helpClass} />
            </a>
          </Container>
          <Container fluid as={Media} lessThan="computer">
            <a href={this.props.helpLink} target="mgt-console-help" className="display-flex">
              <i className={helpClass} />
            </a>
          </Container>
        </div>
      );
    }
    return (
      <span className="header color-modal-header-bg popup-header">
        <div className="display-flex space-between">
          <div>
            <span className="span-like helpTitleWidth">{this.props.title}</span>
            {this.props.subtitle ? <h4 className="no-bold mrtxs">{this.props.subtitle}</h4> : ''}
          </div>
          {this.props.hideHelp ? '' : displayHelpHeader}
        </div>
      </span>
    );
  }
}

// We use this component as universial popup header style.
// Please do not pass any class or css stuff.
// hence, please use the below constaints.
PopupHeader.propTypes = {
  title: PropTypes.string.isRequired,
  helpFunc: PropTypes.func,
  helpLink: PropTypes.string,
};
